var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReactSiteFrame',{attrs:{"src":_vm.src,"hasParams":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }